import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FornecedoresService } from '../fornecedores/fornecedores.service';
import { CategoryService } from '../categories/category.service';
import { TestemunhoService } from '../testemunhos/testemunho.service';
import { DashboardService, SupplierByCategoryPlanDto } from './dashboard.service';

@Component({
  standalone: false,
  selector: 'app-dashboard',
  template: `
    <div class="bg-white p-6 rounded shadow">
      <h1 class="text-3xl font-serif mb-6">Dashboard - Visão Geral</h1>
      
      <!-- KPIs Principais -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <!-- Total de Leads Hoje -->
        <div class="bg-gradient-to-br from-rose-50 to-rose-100 border border-rose-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-rose-700 font-medium">Leads Hoje</p>
              <p class="text-3xl font-bold text-rose-900 mt-1">{{ stats.totalLeadsHoje }}</p>
            </div>
            <div class="text-4xl text-rose-500">📧</div>
          </div>
          <a routerLink="/admin/leads" class="text-xs text-rose-700 hover:underline mt-2 inline-block">Ver auditoria →</a>
        </div>

        <!-- Novos Fornecedores na Semana -->
        <div class="bg-gradient-to-br from-emerald-50 to-emerald-100 border border-emerald-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-emerald-700 font-medium">Novos esta Semana</p>
              <p class="text-3xl font-bold text-emerald-900 mt-1">{{ stats.novosFornecedoresSemana }}</p>
            </div>
            <div class="text-4xl text-emerald-500">🆕</div>
          </div>
          <p class="text-xs text-emerald-700 mt-2">Fornecedores cadastrados</p>
        </div>

        <!-- MRR (Receita Mensal) -->
        <div class="bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-indigo-700 font-medium">MRR</p>
              <p class="text-3xl font-bold text-indigo-900 mt-1">R$ {{ stats.mrr | number:'1.0-0' }}</p>
            </div>
            <div class="text-4xl text-indigo-500">💰</div>
          </div>
          <p class="text-xs text-indigo-700 mt-2">Receita Mensal Recorrente</p>
        </div>

        <!-- Fornecedores Ativos -->
        <div class="bg-gradient-to-br from-cyan-50 to-cyan-100 border border-cyan-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-cyan-700 font-medium">Fornecedores Ativos</p>
              <p class="text-3xl font-bold text-cyan-900 mt-1">{{ stats.fornecedoresAtivos }}</p>
            </div>
            <div class="text-4xl text-cyan-500">✅</div>
          </div>
          <p class="text-xs text-cyan-700 mt-2">{{ stats.fornecedoresInativos }} inativos</p>
        </div>
      </div>

      <!-- Estatísticas Secundárias - Row 1 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <!-- Plano Vitrine -->
        <div class="bg-gradient-to-br from-amber-50 to-amber-100 border border-amber-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-amber-700 font-medium">Plano Vitrine</p>
              <p class="text-3xl font-bold text-amber-900 mt-1">{{ stats.fornecedoresVitrine }}</p>
            </div>
            <div class="text-4xl text-amber-500">⭐</div>
          </div>
          <a routerLink="/admin/fornecedores" class="text-xs text-amber-700 hover:underline mt-2 inline-block">Gerenciar →</a>
        </div>

        <!-- Plano Free -->
        <div class="bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-gray-700 font-medium">Plano Free</p>
              <p class="text-3xl font-bold text-gray-900 mt-1">{{ stats.fornecedoresFree }}</p>
            </div>
            <div class="text-4xl text-gray-500">📦</div>
          </div>
          <a routerLink="/admin/fornecedores" class="text-xs text-gray-700 hover:underline mt-2 inline-block">Gerenciar →</a>
        </div>

        <!-- Leads Mês -->
        <div class="bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-purple-700 font-medium">Leads do Mês</p>
              <p class="text-3xl font-bold text-purple-900 mt-1">{{ stats.totalLeadsMes }}</p>
            </div>
            <div class="text-4xl text-purple-500">📞</div>
          </div>
          <a routerLink="/admin/leads" class="text-xs text-purple-700 hover:underline mt-2 inline-block">Ver auditoria →</a>
        </div>

        <!-- Leads Não Lidos -->
        <div class="bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-orange-700 font-medium">Leads Não Lidos</p>
              <p class="text-3xl font-bold text-orange-900 mt-1">{{ stats.leadsNaoLidos }}</p>
            </div>
            <div class="text-4xl text-orange-500">🔔</div>
          </div>
          <a routerLink="/admin/leads" class="text-xs text-orange-700 hover:underline mt-2 inline-block">Ver leads →</a>
        </div>
      </div>

      <!-- Estatísticas Secundárias - Row 2 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <!-- Total Fornecedores -->
        <div class="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-blue-700 font-medium">Fornecedores</p>
              <p class="text-3xl font-bold text-blue-900 mt-1">{{ stats.totalFornecedores }}</p>
            </div>
            <div class="text-4xl text-blue-500">🏢</div>
          </div>
          <a routerLink="/admin/fornecedores" class="text-xs text-blue-700 hover:underline mt-2 inline-block">Ver todos →</a>
        </div>

        <!-- Receita Prevista -->
        <div class="bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-green-700 font-medium">Renda Prevista</p>
              <p class="text-2xl font-bold text-green-900 mt-1">R$ {{ stats.rendaPrevista | number:'1.0-0' }}</p>
            </div>
            <div class="text-4xl text-green-500">💰</div>
          </div>
          <a routerLink="/admin/financeiro/assinaturas" class="text-xs text-green-700 hover:underline mt-2 inline-block">Ver financeiro →</a>
        </div>

        <!-- Assinaturas Vencendo -->
        <div class="bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-yellow-700 font-medium">Vencendo em 30 dias</p>
              <p class="text-3xl font-bold text-yellow-900 mt-1">{{ stats.assinaturasVencendo30Dias }}</p>
            </div>
            <div class="text-4xl text-yellow-500">⏳</div>
          </div>
          <a routerLink="/admin/financeiro/assinaturas" class="text-xs text-yellow-700 hover:underline mt-2 inline-block">Ver assinaturas →</a>
        </div>

        <!-- Pedidos LGPD -->
        <div class="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-red-700 font-medium">Pedidos LGPD</p>
              <p class="text-3xl font-bold text-red-900 mt-1">{{ stats.removalRequests }}</p>
            </div>
            <div class="text-4xl text-red-500">🔒</div>
          </div>
          <a routerLink="/admin/lgpd" class="text-xs text-red-700 hover:underline mt-2 inline-block">Ver solicitações →</a>
        </div>

        <!-- Adesões Pendentes -->
        <div class="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-blue-700 font-medium">Adesões Pendentes</p>
              <p class="text-3xl font-bold text-blue-900 mt-1">{{ stats.pendingAdhesions }}</p>
            </div>
            <div class="text-4xl text-blue-500">📋</div>
          </div>
          <a routerLink="/admin/adesoes" class="text-xs text-blue-700 hover:underline mt-2 inline-block">Aprovar adesões →</a>
        </div>
      </div>

      <!-- Menu de Navegação -->
      <div class="mb-8">
        <h2 class="text-xl font-semibold mb-4">Navegação Rápida</h2>
        <div class="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          <a routerLink="/admin/adesoes" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📋</div>
            <p class="text-sm font-medium">Adesões</p>
          </a>
          <a routerLink="/admin/coupons" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">🎟️</div>
            <p class="text-sm font-medium">Cupons</p>
          </a>
          <a routerLink="/admin/fornecedores" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">🏢</div>
            <p class="text-sm font-medium">Fornecedores</p>
          </a>
          <a routerLink="/admin/categories" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📁</div>
            <p class="text-sm font-medium">Categorias</p>
          </a>
          <a routerLink="/admin/testemunhos" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">💬</div>
            <p class="text-sm font-medium">Testemunhos</p>
          </a>
          <a routerLink="/admin/newsletter" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📧</div>
            <p class="text-sm font-medium">Newsletter</p>
          </a>
          <a routerLink="/admin/blog" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📝</div>
            <p class="text-sm font-medium">Blog</p>
          </a>
          <a routerLink="/admin/financeiro/assinaturas" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">💳</div>
            <p class="text-sm font-medium">Financeiro</p>
          </a>
          <a routerLink="/admin/leads" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📨</div>
            <p class="text-sm font-medium">Leads</p>
          </a>
          <a routerLink="/admin/lgpd" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">🛡️</div>
            <p class="text-sm font-medium">LGPD</p>
          </a>

          <a routerLink="/admin/config/banners" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">🖼️</div>
            <p class="text-sm font-medium">Banners</p>
          </a>
          <a routerLink="/admin/audit-log" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📜</div>
            <p class="text-sm font-medium">Audit Log</p>
          </a>
          <a routerLink="/admin/institucional" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">⚖️</div>
            <p class="text-sm font-medium">Institucional</p>
          </a>
          <a routerLink="/admin/term-acceptances" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">📜</div>
            <p class="text-sm font-medium">Aceites de Termo</p>
          </a>
          <a routerLink="/admin/supplier-payments" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">💰</div>
            <p class="text-sm font-medium">Pagamentos</p>
          </a>
          <a routerLink="/admin/cidades" class="p-3 border rounded hover:bg-blue-50 border-blue-200 transition text-center">
            <div class="text-2xl mb-1">🌆</div>
            <p class="text-sm font-medium">Cidades</p>
          </a>
          <a routerLink="/admin/destaques-semana" class="p-3 border rounded hover:bg-gray-50 transition text-center">
            <div class="text-2xl mb-1">⭐</div>
            <p class="text-sm font-medium">Popup Destaque</p>
          </a>
        </div>
      </div>

      <!-- Ações Rápidas -->
      <div class="mb-8">
        <h2 class="text-xl font-semibold mb-4">Ações Rápidas</h2>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <a routerLink="/admin/fornecedores/new" class="block p-4 border-2 border-dashed border-primary rounded-lg hover:bg-primary/5 transition text-center">
            <div class="text-3xl mb-2">➕</div>
            <p class="font-medium text-primary">Novo Fornecedor</p>
            <p class="text-xs text-muted mt-1">Cadastrar fornecedor</p>
          </a>

          <a routerLink="/admin/coupons" class="block p-4 border-2 border-dashed border-yellow-500 rounded-lg hover:bg-yellow-50 transition text-center">
            <div class="text-3xl mb-2">🎟️</div>
            <p class="font-medium text-yellow-700">Novo Cupom</p>
            <p class="text-xs text-muted mt-1">Criar cupom promocional</p>
          </a>

          <a routerLink="/admin/adesoes" class="block p-4 border-2 border-dashed border-blue-500 rounded-lg hover:bg-blue-50 transition text-center">
            <div class="text-3xl mb-2">✅</div>
            <p class="font-medium text-blue-700">Aprovar Adesão</p>
            <p class="text-xs text-muted mt-1">Revisar solicitações pendentes</p>
          </a>

          <a routerLink="/admin/lgpd" class="block p-4 border-2 border-dashed border-red-500 rounded-lg hover:bg-red-50 transition text-center">
            <div class="text-3xl mb-2">🔒</div>
            <p class="font-medium text-red-700">Pedidos LGPD</p>
            <p class="text-xs text-muted mt-1">Solicitações de remoção</p>
          </a>

          <a routerLink="/admin/fornecedores" class="block p-4 border-2 border-dashed border-amber-500 rounded-lg hover:bg-amber-50 transition text-center">
            <div class="text-3xl mb-2">⬆️</div>
            <p class="font-medium text-amber-700">Upgrade Fornecedor</p>
            <p class="text-xs text-muted mt-1">Gerenciar planos</p>
          </a>

          <a routerLink="/admin/audit-log" class="block p-4 border-2 border-dashed border-gray-400 rounded-lg hover:bg-gray-50 transition text-center">
            <div class="text-3xl mb-2">📜</div>
            <p class="font-medium text-gray-700">Ver Auditoria</p>
            <p class="text-xs text-muted mt-1">Log de ações do sistema</p>
          </a>
        </div>
      </div>

      <!-- Fornecedores Recentes -->
      <div *ngIf="recentFornecedores.length > 0">
        <h2 class="text-xl font-semibold mb-4">Fornecedores Recentes</h2>
        <div class="space-y-3">
          <div *ngFor="let f of recentFornecedores" class="border border-border rounded p-3 hover:shadow-sm transition">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h3 class="font-medium">{{ f.nome }}</h3>
                <p class="text-sm text-muted">{{ f.cidade || '—' }} • ★ {{ f.rating || '—' }}</p>
              </div>
              <div class="flex gap-2">
                <a [routerLink]="['/admin/fornecedores', f.id, 'edit']" class="text-xs px-3 py-1 border rounded hover:bg-surface">Editar</a>
                <a [routerLink]="['/fornecedores', f.slug]" class="text-xs px-3 py-1 bg-primary text-white rounded hover:bg-primary/90">Ver</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fornecedores Ativos por Categoria e Plano -->
      <div class="mb-8 mt-8">
        <h2 class="text-xl font-semibold mb-4">Fornecedores Ativos por Categoria e Plano</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div *ngFor="let item of suppliersByCategoryPlan" class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <h3 class="font-medium text-gray-900 mb-3">{{ item.categoriaNome }}</h3>
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-600">Plano Free:</span>
                <span class="font-semibold text-gray-900">{{ item.free }}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-sm text-gray-600">Plano Vitrine:</span>
                <span class="font-semibold text-gray-900">{{ item.vitrine }}</span>
              </div>
              <div class="border-t pt-2 mt-2">
                <div class="flex justify-between items-center font-medium">
                  <span class="text-sm text-gray-700">Total:</span>
                  <span class="text-gray-900">{{ item.total }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="suppliersByCategoryPlan.length === 0 && !loading" class="text-center py-8 text-gray-500">
          Nenhum fornecedor ativo encontrado.
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-8 text-muted">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <p class="mt-2 text-sm">Carregando estatísticas...</p>
      </div>
    </div>
  `
})
export class DashboardComponent implements OnInit {
  stats = {
    totalLeadsHoje: 0,
    novosFornecedoresSemana: 0,
    mrr: 0,
    totalFornecedores: 0,
    totalCategorias: 0,
    totalTestemunhos: 0,
    fornecedoresDestaque: 0,
    fornecedoresAtivos: 0,
    fornecedoresInativos: 0,
    totalLeadsMes: 0,
    rendaPrevista: 0,
    assinaturasVencendo30Dias: 0,
    fornecedoresFree: 0,
    fornecedoresVitrine: 0,
    leadsNaoLidos: 0,
    removalRequests: 0,
    pendingAdhesions: 0
  };

  recentFornecedores: any[] = [];
  suppliersByCategoryPlan: SupplierByCategoryPlanDto[] = [];
  loading = true;

  constructor(
    private fornecedoresSvc: FornecedoresService,
    private categorySvc: CategoryService,
    private testemunhoSvc: TestemunhoService,
    private dashboardSvc: DashboardService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadStats();
    this.loadStatsIndividually();
    this.loadSuppliersByCategoryPlan();
  }

  loadStats() {
    this.loading = true;

    // Load fornecedores (first page to get recent)
    this.fornecedoresSvc.adminList({ page: 1, pageSize: 5 }).subscribe({
      next: (res: any) => {
        this.recentFornecedores = (res.data || []).slice(0, 5);
        // Keep loading flag managed in loadStatsIndividually
      },
      error: (err) => {
        console.error('[Dashboard] erro ao carregar fornecedores recentes', err);
      }
    });
  }

  loadStatsIndividually() {
    // Load aggregated stats from single dashboard endpoint
    this.dashboardSvc.getStats().subscribe({
      next: (s) => {
        this.stats.totalFornecedores = s.totalFornecedores;
        this.stats.fornecedoresAtivos = s.fornecedoresAtivos;
        this.stats.fornecedoresInativos = s.fornecedoresInativos;
        this.stats.novosFornecedoresSemana = s.novosFornecedoresSemana;
        this.stats.totalLeadsHoje = s.totalLeadsHoje;
        this.stats.totalLeadsMes = s.totalLeadsMes;
        this.stats.rendaPrevista = s.rendaPrevista;
        this.stats.mrr = s.mrr;
        this.stats.assinaturasVencendo30Dias = s.assinaturasVencendo30Dias;
        this.stats.fornecedoresFree = s.fornecedoresFree;
        this.stats.fornecedoresVitrine = s.fornecedoresVitrine;
        this.stats.leadsNaoLidos = s.leadsNaoLidos;
        this.stats.removalRequests = s.removalRequests;
        this.stats.pendingAdhesions = s.pendingAdhesions;
      },
      error: (err) => {
        console.error('[Dashboard] erro ao carregar estatísticas do dashboard', err);
      }
    });

    // Count fornecedores em destaque usando o novo filtro
    this.fornecedoresSvc.adminList({ page: 1, pageSize: 1, destaque: 'sim' }).subscribe({
      next: (destaqueRes: any) => {
        this.stats.fornecedoresDestaque = destaqueRes.meta?.total || destaqueRes.total || 0;
      },
      error: () => {
        this.stats.fornecedoresDestaque = 0;
      }
    });

    // Load categorias
    this.categorySvc.listAll().subscribe({
      next: (res: any) => {
        const cats = (res && res.data) ? res.data : (Array.isArray(res) ? res : []);
        this.stats.totalCategorias = cats.length;
      },
      error: (err) => {
        console.error('[Dashboard] erro ao carregar categorias', err);
      }
    });

    // Load testemunhos
    this.testemunhoSvc.adminList(1, 1).subscribe({
      next: (res: any) => {
        this.stats.totalTestemunhos = res.meta?.total || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('[Dashboard] erro ao carregar testemunhos', err);
        this.loading = false;
      }
    });
  }

  loadSuppliersByCategoryPlan() {
    this.dashboardSvc.getActiveSuppliersByCategoryAndPlan().subscribe({
      next: (data: SupplierByCategoryPlanDto[]) => {
        this.suppliersByCategoryPlan = data;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('[Dashboard] erro ao carregar fornecedores por categoria e plano', err);
      }
    });
  }
}
